import React from 'react';

import styled from 'styled-components';
import { themeColor } from '@utils/styledTheme.util';

export const PricingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${themeColor('red1')};
  border-bottom-right-radius: 64px;
  height: 100%;
  padding: 80px 0;
  margin-bottom: 40px;
`;

export const Flex = styled.div<{ justifyContent: string; marginBottom?: string; mobileJustifyContent?: string }>`
  display: flex;
  align-items: center;
  justify-content: ${(props) => (props.mobileJustifyContent ? props.mobileJustifyContent : props.justifyContent)};
  margin-bottom: ${(props) => props.marginBottom};
  @media (min-width: 768px) {
    justify-content: ${(props) => props.justifyContent};
  }
`;

export const NumberWrapper = styled.div`
  display: flex;
  align-items: center;
  height: 256px;
`;

export const Check = () => (
  <div style={{ marginRight: '20px' }}>
    <svg width="26" height="20" viewBox="0 0 26 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.6701 10.4576C1.26016 10.0875 0.62782 10.1198 0.257732 10.5297C-0.112356 10.9397 -0.0800464 11.572 0.329897 11.9421L1.6701 10.4576ZM9.64 18.9998L8.9699 19.7421C9.16795 19.9209 9.42924 20.0131 9.69564 19.9983C9.96204 19.9834 10.2115 19.8627 10.3884 19.6631L9.64 18.9998ZM25.7484 2.32972C26.1147 1.91638 26.0766 1.28437 25.6632 0.918079C25.2499 0.551793 24.6179 0.589941 24.2516 1.00328L25.7484 2.32972ZM0.329897 11.9421L8.9699 19.7421L10.3101 18.2576L1.6701 10.4576L0.329897 11.9421ZM10.3884 19.6631L25.7484 2.32972L24.2516 1.00328L8.89157 18.3366L10.3884 19.6631Z"
        fill="#200041"
      />
    </svg>
  </div>
);
